
import React from 'react'

import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import DrBrekhna_CV from '../../../assets/CVs/Computer Science/DrBrekhna_CV.pdf' 
import DRtabindasalam_CV from '../../../assets/CVs/Computer Science/DRtabindasalam_CV.pdf'
import DrFouziaIdrees_CV from '../../../assets/CVs/Computer Science/DrFouziaIdrees_CV.pdf'
// import MsSADIAHABIBRESUME from '../../../assets/CVs/Biochemistry/DrMAMOONAALAM_Cv.pdf'
import Footer from '../../../Components/Footer'


const Computer = () => {
  return (

    <>
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Computer Science</h2>
       
        <p>Faculty of Computer Science.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Fouzia Idrees</h4>
              <span>Lecturer Department of Computer Science.</span>
              <p>Lecturer Department of Computer Science Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   fouzia.idrees@sbbwu.edu.pk   </p>
              <div className="social">
                <a href={DrFouziaIdrees_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Brekhna </h4>
              <span>Assistant Professor Department of Computer Science.</span>
              <p>Assistant Professor Department of Computer Science, Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> brekhna87@gmail.com   </p>
              <div className="social">
                <a href={DrBrekhna_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Tabinda Salam</h4>
              <span> Lecturer Department of Computer Science.</span>
              <p> Lecturer Department of Computer Science, Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  tabindasalam@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DRtabindasalam_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
      </>
  )
}


export default Computer
